module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiCn.1bd0952.eot";